import { INJECT_VIDEO_LOGO, InjectVideoLogoParams } from './primaryHeader.actions';

type Link = {
    text: string;
    href: string;
};

export interface MenuLink extends Link {
    childrenLinks: Array<Link>;
}

export interface PrimaryHeaderState {
    logo: {
        svgLarge: string;
        svgSmall: string;
        svgLargeViewBox: string;
        svgSmallViewBox: string;
        alt: string;
        href: string;
    };
    links: Array<Link> | null;
    editions: Array<Link> | null;
    cta: Link | null;
    menu: Array<MenuLink> | null;
    pagePath: string;
    editionEndpoint: string;
    videoLogo: InjectVideoLogoParams | null;
}

interface InjectVideoLogoAction {
    type: typeof INJECT_VIDEO_LOGO;
    videoPath: string;
}

export type HomePageAction = InjectVideoLogoAction;

export const primaryHeaderReducer = (state: PrimaryHeaderState = {} as PrimaryHeaderState, action: HomePageAction) => {
  switch (action.type) {
      case INJECT_VIDEO_LOGO: {
          const { videoPath } = action;
          return {
              ...state,
              videoLogo: {
                  videoPath,
              },
          };
      }
    default:
      return state;
  }
};
